import { Button, Modal } from "react-bootstrap";

function ConfirmGeneric(props) {
  const { message, onConfirm, onClose, show } = props;

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Please Confirm Your Action</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={onConfirm}>
          OK
        </Button>
        <Button variant="success" onClick={onClose}>
          Abort
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmGeneric;
